import {
  forwardRef,
  TabPanel as ChakraTabPanel,
  type TabPanelProps,
} from '@/ui';

export const FilterTabPanel = forwardRef((props: TabPanelProps, ref) => (
  <ChakraTabPanel ref={ref} {...props} pb="2" pt="1" px="2" />
));
